import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import axios from 'axios';
import PropTypes from 'prop-types';

import api from '@/apiRequest';
import AddCroquiComponent from '@/components/AddCroqui/AddCroquiComponent';
import { useOrderMutations } from '@/hooks/useOrderMutations';
import { showToast } from '@/store/ducks/toasts';

let extension;
const AddCroquiContainer = ({ orderId, closeModal }) => {
  const [uploadDone, setUploadDone] = useState(false);
  const intl = useIntl();
  const dispatch = useDispatch();
  const { confirmCroquiSent } = useOrderMutations(orderId);

  const getUploadUri = async extension => {
    const { data } = await api.get(`/orders/${orderId}/croqui-upload-uri?file_extension=${extension}`);
    return data.uri;
  };


  const setCroquiSent = async () => {
    confirmCroquiSent.mutate(
      { filename: `croqui.${extension}` },
      {
        onSuccess: () => {
          dispatch(
            showToast({
              type: 'success',
              title: intl.formatMessage({ id: 'SUCCESS' }),
              text: intl.formatMessage({ id: 'ADD_CROQUI_SUCCESS_MESSAGE' }),
              duration: 5000,
            })
          );
          closeModal();
        },
        onError: () => {
          dispatch(
            showToast({
              type: 'error',
              title: intl.formatMessage({ id: 'ERROR' }),
              text: intl.formatMessage({ id: 'ADD_CROQUI_ERROR_MESSAGE' }),
              duration: 5000,
            })
          );
        },
      }
    );
  };


  const handleChange = async image => {
    try {
      extension = image.name.indexOf('.' > 0) ? image.name.split('.').pop() : '';
      const uri = await getUploadUri(extension); // get signed uri
      const form = new FormData();
      form.set('file', image);
      await axios.put(uri, image, {
        headers: {
          'Content-Type': image.type,
        },
      }); // do s3 upload
      setUploadDone(true);
    } catch (err) {
      console.log('err', err);
    }
  };

  const handleCancel = () => {
    closeModal();
  };

  const handleSubmit = async () => {
    if (uploadDone) {
      await setCroquiSent();
    }
  };

  return (
    <AddCroquiComponent
      handleChange={handleChange}
      handleCancel={handleCancel}
      handleSubmit={handleSubmit}
      intl={intl}
    />
  );
};

AddCroquiContainer.propTypes = {
  orderId: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default AddCroquiContainer;
